import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import SubmitActions from 'app/common/components/forms/submit-actions';
import { GeneralAccountFields, validateAccountInfo } from './general-account-fields';

import './general-account.less';

function changeEmailLink() {
  return `${global.sharedEnv.USER_SERVICE_SERVER}/users/email_change`;
}

let GeneralAccountForm = props => (
  <form className='GeneralAccountForm' onSubmit={props.handleSubmit}>
    {GeneralAccountFields(true, { changeEmailLink: changeEmailLink() })}
    <SubmitActions {...props} />
  </form>
);

GeneralAccountForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

// Decorate the form component
GeneralAccountForm = reduxForm({
  form: 'generalAccount',
  enableReinitialize: true,
  validate: validateAccountInfo,
})(GeneralAccountForm);


// General Account Form Wrapper with heading
const GeneralAccount = props => (
  <div className='GeneralAccount'>
    <h1 className='h2'>General Account Settings</h1>
    <GeneralAccountForm {...props} />
  </div>
);

export default GeneralAccount;



// WEBPACK FOOTER //
// ./app/components/settings/general-account.jsx